import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  name: string;
};

export const FillTheFieldErrorMessage: FC<Props> = ({ name }) => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div className={styles.error}>
      <ErrorMessage name={name} errors={errors} />
    </div>
  );
};
